<template>
    <v-layout
        row
        :style="maxWidth"
    >
        <v-flex
            class="ml-3"
            :style="maxWidth"
        >
        <v-card
            class="mx-auto"
            tile
            v-if="outlet.bg_image"
            max-height="400"
        >
            <v-img
                v-if="outlet.logo"
                :src="myLogo"
                class="my-logo"
                alt="logo"
                max-height="100"
                max-width="100"
                style="margin-left: -50px;top: 50%;z-index: 200;position: absolute;left: 50%;"
                contain
            />
            <v-img
                class="white--text align-end"
                :src="myBackground"
                alt="background"
                max-height="400"
            >
                <v-card-text
                    :style="sloganStyle"
                >
                    {{ outlet.slogan }}
                </v-card-text>
            </v-img>
        </v-card>
        <v-snackbar
            v-model="success"
            color="success"
            :timeout="5000"
            top
        >
            Added to Queue!
        </v-snackbar>
        <v-snackbar
            v-model="error"
            color="error"
            :timeout="5000"
            top
        >
            {{ error_msg }}
        </v-snackbar>
        <v-container>
            <div
                style="text-align: center"
            >
                <div
                    class="col-sm-12"
                    style="display: inline-block;"
                    v-for="(queue, index) in queues"
                >
                    <v-btn
                        :class="btnFontClass"
                        :key="index"
                        x-large
                        :color="btnColor"
                        :style="btnTextSize(queue)"
                        @click="checkDeclaration(queue)"
                    >
                        {{ queue.name }}
                    </v-btn>
                </div>
            </div>
        </v-container>
        <!-- Queue Form  -->
        <v-row justify="center">
            <v-dialog
                v-model="showQueueForm"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-card-title
                        :style="formStyle"
                        :class="btnFontClass"
                        class="justify-center pa-12"
                    >
                        {{ longQueue ? 'Long Queue Ahead' : selectedQueue.name }}
                    </v-card-title>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title v-if="outlet.onsite_information_content" class="headline text-center text-wrap">
                                <div v-html="formattedInformation"></div>
                            </v-list-item-title>
                            <div v-else>
                              <v-list-item-title class="headline text-center text-wrap" style="max-width: available">There are <span
                                  style="text-decoration: underline;font-weight: bold">{{ queueLength }}</span> queues
                                  before
                                  you
                              </v-list-item-title>
                              <v-list-item-title class="headline text-center text-wrap" v-if="outlet.id !== 21">Your queue number will <span
                                  v-if="longQueue" style="font-weight: bold">ONLY</span> be called around
                                  <span style="text-decoration: underline;font-weight: bold">{{ estimateTime }}</span>
                              </v-list-item-title>
                              <v-list-item-title v-if="outlet.id !== 3" class="headline text-center text-wrap">Enter your phone
                                  number, we will notify you
                                  when its your turn
                              </v-list-item-title>
<!--                              <v-list-item-title v-if="selectedQueue.id !== 3" class="headline text-center text-wrap">Enter your phone-->
<!--                                number, we will notify you-->
<!--                                when its your turn-->
<!--                              </v-list-item-title>-->
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                    <v-form class="ma-4">
                        <v-row
                            justify="center"
                        >
                            <v-text-field
                                v-if="outlet.onsite_name"
                                v-model="name"
                                label="Name"
                                outlined
                                class="col-9 col-sm-6 ma-2"
                                autocomplete="off"
                            ></v-text-field>
                        </v-row>
                        <v-row
                            justify="center"
                        >
                            <vue-tel-input
                                ref="telInput"
                                v-if="outlet.onsite_phone"
                                v-model="phone"
                                @input="onMobileInput"
                                name="phone"
                                defaultCountry="SG"
                                :onlyCountries="['SG', 'MY', 'CN', 'HK']"
                                required
                                :maxLen="15"
                                enabledCountryCode
                                validCharactersOnly
                                :wrapperClasses="['mobile-input']"
                                @validate="validateMobile"
                                class="col-9 col-sm-6 ma-2"
                                autocomplete="off"
                            ></vue-tel-input>
                        </v-row>
                        <v-row
                            v-if="phone.length > 0 && !mobileIsValid"
                            justify="center"
                            style="margin-top: -18px; margin-bottom: 5px;"
                        >
                            <v-flex class="col-9 col-sm-6 ml-1">
                                <span style="font-size: 10px; color: red">Your mobile number is invalid</span>
                            </v-flex>
                        </v-row>
                        <v-row
                            justify="center"
                        >
                            <v-text-field
                                v-if="outlet.onsite_email"
                                v-model="email"
                                label="Email"
                                outlined
                                class="col-9 col-sm-6 ma-2"
                                autocomplete="off"
                                type="email"
                            ></v-text-field>
                        </v-row>
                        <v-row justify="center" v-if="selectedQueue.allow_pax_input">
                          <v-flex class="col-9 col-sm-6 ml-1">
                          <v-list-item-title class="headline text-wrap">
                            <v-label>Pax</v-label>
                          </v-list-item-title>
                            <v-radio-group v-model="pax" row>
                              <v-radio
                                  v-for="n in selectedQueue.pax_limit"
                                  :key="n"
                                  :label="`${n}`"
                                  :value="n"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-row>
                        <v-row
                            justify="center"
                        >
                            <v-text-field
                                v-if="outlet.onsite_remarks"
                                v-model="remarks"
                                :label='outlet.onsite_remarks_label'
                                outlined
                                class="col-9 col-sm-6 ma-2"
                                autocomplete="off"
                            ></v-text-field>
                        </v-row>
                    </v-form>
                    <v-card-actions class="justify-center">
                        <v-btn
                            @click="clear()"
                            x-large
                            :width="$vuetify.breakpoint.xs ? '150px' : '300px'"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            :class="btnFontClass"
                            :color="btnColor"
                            @click="confirm()"
                            x-large
                            :width="$vuetify.breakpoint.xs ? '150px' : '300px'"
                        >Get Queue
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="hasServices"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-card-title
                        :style="formStyle"
                        class="pa-8"
                    >
                        <v-row>
                            <v-col
                                cols="1"

                            >
                                <v-btn
                                    :style="formStyle"
                                    @click="hasServices = !hasServices"
                                    depressed
                                >
                                    <v-icon
                                        :color="outlet.main_font_color"
                                        x-large
                                    >keyboard_arrow_left
                                    </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                :class="btnFontClass"
                                class="text-center"
                            >
                                Select Service
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-container>
                        <div
                            style="text-align: center"
                        >
                            <div
                                class="col-sm-12"
                                v-for="(service, index) in qServices"
                            >
                                <v-btn
                                    :class="btnFontClass"
                                    :key="index"
                                    x-large
                                    :color="btnColor"
                                    style="font-weight: bold;"
                                    @click="checkService(service)"
                                >
                                    {{ service.name }}
                                </v-btn>
                            </div>
                        </div>
                    </v-container>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Queue Form End -->
        <!-- Confirm Phone -->
        <v-row justify="center">
            <v-dialog
                v-model="showConfirm"
                hide-overlay
            >
                <v-card>
                    <v-card-title
                        :style="confirmStyle"
                        class="justify-center pa-8"
                    >
                        Please confirm your phone number
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text
                        class="display-3 text-center"
                    >{{ phone }}
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                            @click="showConfirm = false"
                            x-large
                            :width="$vuetify.breakpoint.xs ? '150px' : '300px'"
                        >
                            Change
                        </v-btn>
                        <v-btn
                            :class="btnFontClass"
                            :color="btnColor"
                            @click="getQueueNo()"
                            x-large
                            :width="$vuetify.breakpoint.xs ? '150px' : '300px'"
                            :disabled="isLoading"
                        >Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Confirm Phone End -->
        <!-- Show Details -->
        <v-row justify="center">
            <v-dialog
                v-model="showDetails"
                fullscreen
            >
                <v-card v-if="outlet.id === 3">
                    <v-card-title
                        :style="formStyle"
                        :class="btnFontClass"
                        class="justify-center pa-12"
                    >
                        {{ outlet.name }}
                    </v-card-title>
                    <!--                    <div v-if="outlet.onsite_details_content">-->
                    <!--                        <p v-html="customContent"></p>-->
                    <!--                    </div>-->
                    <!--                    <div v-else>-->
                    <v-card-text
                        class="pt-10 text-center"
                        style="font-size: x-large"
                    >There are {{ queueLength }} in queue before you for {{ selectedQueue.name }}.
                    </v-card-text>
                    <v-card-text
                        class="text-center"
                        style="font-size: x-large"
                    >
                        Please have a sit and you will be served soon.
                    </v-card-text>
                    <!--                    </div>-->
                </v-card>
                <v-card v-else>
                    <v-card-title
                        :style="formStyle"
                        :class="btnFontClass"
                        class="justify-center pa-12"
                    >
                        {{ outlet.name }}
                    </v-card-title>
                    <div v-if="outlet.onsite_details_content">
                        <p v-html="customContent"></p>
                    </div>
                    <div v-else>
                        <v-card-text
                            class="text-center"
                        >Your Queue No. for {{ selectedQueue.name }} is
                        </v-card-text>
                        <v-card-text
                            class="display-3 text-center"
                        >{{ q_no }}
                        </v-card-text>
                        <v-card-text
                            class="text-center"
                        >There are {{ queueLength }} queues before you
                        </v-card-text>
                        <v-card-text
                            class="text-center"
                        >Your queue number will be called around
                        </v-card-text>
                        <v-card-text
                            class="display-3 text-center"
                        >{{ estimateTime }}
                        </v-card-text>
                    </div>
                    <v-card-actions class="justify-center" v-if="!selectedQueue.direct_print">
                        <v-btn
                            @click="clear()"
                            x-large
                            width="300px"
                        >
                            Close
                        </v-btn>
                        <v-btn
                            :class="btnFontClass"
                            :color="btnColor"
                            @click="printOut()"
                            x-large
                            width="300px"
                        >Print
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Show Details End -->
        <!-- Show Declaration -->
        <v-row justify="center">
            <v-dialog
                v-model="showDeclaration"
                persistent
                width="800"
            >
                <v-card>
                    <v-card-title
                        class="headline lighten-2"
                    >
                        Declaration by Patient/Visitor
                    </v-card-title>
                    <hr class="ma-0 pa-0">
                    <div class="pl-3">
                        <v-row>
                            <v-col cols="9">
                                <v-card-text>
                                    1. Have you travelled abroad (i.e. to any countries outside of Singapore) in the
                                    <span class="highlight">past 14 days</span>?
                                </v-card-text>
                            </v-col>
                            <v-col cols="3">
                                <v-radio-group
                                    v-model="travel"
                                    row>
                                    <v-radio
                                        value="1"
                                        label="Yes"
                                    >
                                    </v-radio>
                                    <v-radio
                                        value="0"
                                        label="No"
                                    >
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="9">
                                <v-card-text>
                                    2. Do you have <span class="highlight">flu-like symptoms</span> (e.g. fever, cough,
                                    runny nose, sore throat or loss of taste / smell, etc.)?
                                </v-card-text>
                            </v-col>
                            <v-col cols="3">
                                <v-radio-group
                                    v-model="symptoms"
                                    row>
                                    <v-radio
                                        value="1"
                                        label="Yes"
                                    >
                                    </v-radio>
                                    <v-radio
                                        value="0"
                                        label="No"
                                    >
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="9">
                                <v-card-text>
                                    3. Are you currently serving: <br>
                                    &nbsp;&nbsp;(i) <span class="highlight">Stay-Home Notice (SHN)</span>; OR <br>
                                    &nbsp;&nbsp;(ii) <span class="highlight">Quarantine Order (QO)</span> issued by the
                                    Ministry of Health (MOH)?
                                </v-card-text>
                            </v-col>
                            <v-col cols="3">
                                <v-radio-group
                                    v-model="servingNotice"
                                    row>
                                    <v-radio
                                        value="1"
                                        label="Yes"
                                    >
                                    </v-radio>
                                    <v-radio
                                        value="0"
                                        label="No"
                                    >
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="9">
                                <v-card-text>
                                    4. Have you had close contact with a <span
                                    class="highlight">confirmed COVID-19 case</span> in the <span class="highlight">past 14 days</span>?
                                </v-card-text>
                            </v-col>
                            <v-col cols="3">
                                <v-radio-group
                                    v-model="closeContact"
                                    row>
                                    <v-radio
                                        value="1"
                                        label="Yes"
                                    >
                                    </v-radio>
                                    <v-radio
                                        value="0"
                                        label="No"
                                    >
                                    </v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-card-subtitle style="font-size: 12px">The information you provide is important in managing
                            the risk of COVID-19 transmission. The Infectious Diseases Act requires a person who has
                            reason to suspect that he is a case or carrier of COVID-19, or has had contact with a person
                            with COVID-19, to act in a responsible manner to not expose other persons to the risk of
                            infection by the disease.
                        </v-card-subtitle>
                        <v-card-actions>
                            <v-btn
                                large
                                class="success"
                                @click="submitDeclaration"
                            >
                                Submit
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Show Declaration End -->
        <!-- Declaration Alert -->
        <v-row justify="center">
            <v-dialog
                v-model="declarationAlert"
                width="800"
            >
                <v-card>
                    <v-card class="pl-3">
                        <v-row>
                            <v-col cols="1" align-self="center">
                                <v-icon
                                    color="red"
                                    x-large
                                >report
                                </v-icon>
                            </v-col>
                            <v-col>
                                <v-card-text>
                                    {{ declarationMsg }}
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>
            </v-dialog>
        </v-row>
        <!-- Declaration Alert End -->
            <v-dialog
                v-model="screensaver"
                fullscreen
            >
                <v-card @click="screensaver = false">
                    <v-img
                        class="white--text align-end"
                        :src="myScreenSaver"
                        alt="background"
                    >
                    </v-img>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'
import QueueForm from './Queues/QueueForm'
import {VueTelInput} from 'vue-tel-input'
import moment from 'moment'

export default {
    name: 'outlet',
    props: ['outlet', 'role_id'],
    components: {
        'queue-form': QueueForm
    },
    data: () => {
        return {
            showQueueForm: false,
            name: '',
            phone: '',
            email: '',
            remarks: '',
            customContent: '',
            internationalPhone: '',
            selectedQueue: '',
            success: false,
            error: false,
            error_msg: '',
            queueLength: 0,
            estimateTime: '',
            longQueue: false,
            mobileIsValid: false,
            showConfirm: false,
            countryCodes: [
                {'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore'},
                {'flag': '🇨🇳', 'country_code': 86, 'name': 'China'},
                {'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China'},
                {'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia'},
            ],
            available: true,
            hasServices: false,
            qServices: null,
            selectedServices: '',
            pax: null,
            printerIP: null,
            q_no: '',
            showDetails: false,
            showDeclaration: false,
            timeout: null,
            isLoading: null,
            appointment_time: null,
            travel: null,
            symptoms: null,
            servingNotice: null,
            closeContact: null,
            tempQ: null,
            declarationAlert: false,
            declarationMsg: null,
            screensaver: null,
            queues: []
        }
    },
    computed: {
        formStyle() {
            return {
                backgroundColor: this.outlet.main_color ? this.outlet.main_color : 'black',
                color: this.outlet.main_font_color ? this.outlet.main_font_color : 'white',
                fontWeight: "bold",
                fontSize: "30px",
                wordBreak: "break-word",
                textAlign: 'center',
            }
        },
        confirmStyle() {
            return {
                fontSize: "30px",
                wordBreak: "break-word"
            }
        },
        myBackground() {
            return '/storage' + this.outlet.bg_image;
        },
        myScreenSaver() {
            return this.outlet.screen_saver_img ? '/storage' + this.outlet.screen_saver_img : '/storage' + this.outlet.bg_image;
        },
        myLogo() {
            return '/storage' + this.outlet.logo;
        },
        btnColor() {
            return this.outlet.main_color ? this.outlet.main_color : 'black';
        },
        btnFontClass() {
            let c = this.outlet.main_font_color ? this.outlet.main_font_color : 'white';
            return c + '--text'
        },
        sloganStyle() {
            return {
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '40px',
                color: this.outlet.slogan_color ? this.outlet.slogan_color : '#000000'
            }
        },
        maxWidth() {
            return {
                maxWidth: window.outerWidth + 'px'
            }
        },
        formattedInformation() {
            let text = this.outlet.onsite_information_content.replace('{qName}', this.selectedQueue.name)
            text = text.replaceAll('{qNo}', this.q_no)
            text = text.replaceAll('{qLength}', this.queueLength)
            text = text.replaceAll('{estimatedTime}', this.estimateTime)
            text = text.replaceAll('{currentTime}', moment().format('hh:mm A'))
            text = text.replaceAll('{currentDate}', moment().format('YYYY-MM-DD'))
            text = text.replaceAll('{currentDateTime}', moment().format('YYYY-MM-DD hh:mm A'))

            let specialTime, specialTime2
            if(moment().isBefore(moment('09:00am', 'h:mma'))){
                specialTime = '09:00 am'
                specialTime2 = '09:15 am'
            }
            if(moment().isBetween(moment('09:00am', 'h:mma'), moment('02:00pm', 'h:mma'))){
                specialTime = '14:00 am'
                specialTime2 = '14:15 am'
            }
            if(moment().isBetween(moment('02:00pm', 'h:mma'), moment('06:00pm', 'h:mma'))){
                specialTime = '18:00 am'
                specialTime2 = '18:15 am'
            }

            text = text.replaceAll('{specialTime}', specialTime)
            text = text.replaceAll('{specialTime2}', specialTime2)

            return text
        }
    },
    methods: {
        btnTextSize(q) {
            let size = 'large';
            if (q.name.length > 20 && q.name.length < 30) size = 'large';
            if (q.name.length > 30) size = 'medium';

            if (window.innerWidth < 500) {
                size = '12px'
            }
            return {
                fontSize: size,
                fontWeight: 'bold',
                marginTop: '16px',
                marginBottom: '16px',
            }
        },
        paxRules(v) {
            if (v <= this.selectedQueue.limit) {
                return true
            } else {
                return 'Over Limit!'
            }
        },

        checkDeclaration(q) {
            // check declaration
            if (this.outlet.health_declaration) {
                this.tempQ = q
                this.showDeclaration = true
            } else {
                this.showForm(q)
            }
        },

        showForm(q) {
            // this.isLoading = true;
            axios.get('/queue/' + q.id + '/list?filter=service', {
                queue_id: q.id,
            }).then(response => {
                this.hasServices = response.data.hasServices;
                this.qServices = response.data.qServices;
                this.selectedQueue = q;
                if (!this.hasServices) {
                    this.queueLength = 0;
                    this.longQueue = false;
                    this.name = '';
                    this.phone = '';
                    this.email = '';
                    this.remarks = '';
                    this.internationalPhone = '';
                    // get q length
                    axios.get('/queue/' + this.selectedQueue.id + '/list?filter=length').then(response => {
                        if (response.data) this.queueLength = response.data;
                    });
                    axios.get('/queue/' + this.selectedQueue.id + '/list?filter=time').then(response => {
                      console.log(response.data)
                        if (response.data) {
                            this.estimateTime = response.data.estimateTimeString;
                            const t = new Date(response.data.estimateTime);
                            const now = new Date();
                            this.longQueue = t.getHours() - now.getHours() >= 2;
                            this.available = response.data.availableToday;

                            let msg = response.data.msg;

                            if (this.available) {
                                this.showQueueForm = true;
                            }
                            // if got next available timeslot, then queue to next slot
                            if (!this.available && response.data.nextAvailable !== '') {
                                this.appointment_time = response.data.nextAvailable;
                                this.showQueueForm = true;
                            }
                            // if no next available timeslot
                            if (!this.available && response.data.nextAvailable === '') {
                                this.showQueueForm = false;
                                this.error = true;
                                let unavailable_msg = 'The Queue is currently not available!'
                                if (this.outlet.onsite_unavailable_message) {
                                    unavailable_msg = this.outlet.onsite_unavailable_message.replace('{qName}', this.selectedQueue.name)
                                }
                                this.error_msg = msg ? msg : unavailable_msg;
                            }
                        }
                    })
                }
            });
        },
        async getQueueNo() {
            this.isLoading = true;
            if (this.outlet.onsite_phone && (this.phone.length === 0 || !this.mobileIsValid || this.internationalPhone.length === 0)) {
                this.isLoading = null;
                return false;
            } else {
                let service_id = null;
                if (this.selectedServices !== '') {
                    service_id = this.selectedServices.id
                }
                await axios.post('/outlet/' + this.outlet.id + '/queue/addToQueue/' + this.selectedQueue.id, {
                    queue_id: this.selectedQueue.id,
                    name: this.name,
                    phone_no: this.internationalPhone,
                    email: this.email,
                    pax: this.pax,
                    remarks: this.remarks,
                    service_id: service_id,
                    appointment_time: this.appointment_time,
                    type: 'onsite',
                }).then(response => {
                    if (response.data.error_msg) {
                        this.error = true;
                        this.error_msg = response.data.error_msg;
                    } else {
                        this.q_no = response.data.queue_no;
                        this.showConfirm = false;
                        this.showQueueForm = false;
                        this.success = true;
                        if (this.outlet.onsite_details_content) this.formatDetailsContent()
                        if (this.selectedQueue.onsite_print) {
                            this.showDetails = true;
                            if (this.selectedQueue.direct_print) {
                                this.printOut()
                            }
                            this.timeout = setInterval(() => {
                                this.showDetails = false
                                this.clear()
                            }, 10000);
                        } else {
                            this.clear();
                        }
                    }
                });
            }
        },
        formatDetailsContent() {
            this.customContent = this.outlet.onsite_details_content.replace('{qName}', this.selectedQueue.name)
            console.log(this.customContent)
            this.customContent = this.customContent.replaceAll('{qNo}', this.q_no)
            this.customContent = this.customContent.replaceAll('{qLength}', this.queueLength)
            this.customContent = this.customContent.replaceAll('{estimatedTime}', this.estimateTime)
            this.customContent = this.customContent.replaceAll('{currentTime}', moment().format('hh:mm A'))
            this.customContent = this.customContent.replaceAll('{currentDate}', moment().format('YYYY-MM-DD'))
            this.customContent = this.customContent.replaceAll('{currentDateTime}', moment().format('YYYY-MM-DD hh:mm A'))

            let specialTime, specialTime2
            if(moment().isBefore(moment('09:00am', 'h:mma'))){
                specialTime = '09:00 am'
                specialTime2 = '09:15 am'
            }
            if(moment().isBetween(moment('09:00am', 'h:mma'), moment('02:00pm', 'h:mma'))){
                specialTime = '14:00 am'
                specialTime2 = '14:15 am'
            }
            if(moment().isBetween(moment('02:00pm', 'h:mma'), moment('06:00pm', 'h:mma'))){
                specialTime = '18:00 am'
                specialTime2 = '18:15 am'
            }

            this.customContent = this.customContent.replaceAll('{specialTime}', specialTime)
            this.customContent = this.customContent.replaceAll('{specialTime2}', specialTime2)
        },
        async confirm() {
            console.log('confirm')
            await this.$refs.telInput.onInput();
            console.log('confirm after on input')

            if (!this.outlet.onsite_phone) {
                await this.getQueueNo()
            } else {
                if (this.phone.length === 0 || !this.mobileIsValid || this.internationalPhone.length === 0) {
                    return false;
                } else {
                    this.showConfirm = true
                }
            }
        },
        clear() {
            this.selectedServices = '';
            this.selectedQueue = '';
            this.showQueueForm = false;
            this.name = '';
            this.phone = '';
            this.email = '';
            this.pax = null;
            this.remarks = '';
            this.internationalPhone = '';
            this.selectedQueue = '';
            this.success = false;
            this.error = false;
            this.error_msg = '';
            this.queueLength = 0;
            this.estimateTime = '';
            this.longQueue = false;
            this.mobileIsValid = false;
            this.showConfirm = false;
            this.queue_no = '';
            this.showDetails = false;
            this.appointment_time = null;
            this.isLoading = null;
            this.timeout = clearInterval(this.timeout);
        },
        onMobileInput(value, phoneObject, input) {
            console.log('onMobileInput');
            console.log(value);
            console.log(phoneObject);
            console.log(input);
            this.validateMobile(phoneObject)
        },
        validateMobile(phoneObject) {
            console.log('validateMobile')
            this.mobileIsValid = phoneObject.valid;
            this.country_code = phoneObject.country_code;
            if (phoneObject.valid && phoneObject.nationalNumber) {
                this.internationalPhone = phoneObject.country.dialCode + phoneObject.nationalNumber
            }
        },
        openMobile() {
            // Manually set using JS because CSS isn't applying the style
            const dropdownElementStyle = document.getElementsByClassName('vti__dropdown')[0].childNodes[2].style;
            if (dropdownElementStyle) {
                dropdownElementStyle.fontSize = "14px";
                dropdownElementStyle.width = "250px";
            }
        },
        checkService(service) {
            this.hasServices = false;
            // check available, time estimate, queue length
            this.selectedServices = service;
            this.queueLength = 0;
            this.longQueue = false;
            this.name = '';
            this.phone = '';
            this.email = '';
            this.remarks = '';
            this.internationalPhone = '';

            axios.get('/queue/' + this.selectedQueue.id + '/list?filter=length').then(response => {
                if (response.data) this.queueLength = response.data;
            });
            axios.get('/queue/' + this.selectedQueue.id + '/list?filter=time&service_id=' + this.selectedServices.id).then(response => {
                this.estimateTime = response.data.estimateTimeString;
                const t = new Date(response.data.estimateTime);
                const now = new Date();
                this.longQueue = t.getHours() - now.getHours() >= 2;
                this.available = response.data.availableToday;
                let msg = response.data.msg;

                if (this.available) {
                    this.showQueueForm = true;
                }

                // if got next available timeslot, then queue to next slot
                if (!this.available && response.data.nextAvailable !== '') {
                    this.appointment_time = response.data.nextAvailable;
                    this.showQueueForm = true;
                }
                // if no next available timeslot
                if (!this.available && response.data.nextAvailable === '') {
                    this.showQueueForm = false;
                    this.error = true;
                    let unavailable_msg = 'The Queue is currently not available!'
                    if (this.outlet.onsite_unavailable_message) {
                        unavailable_msg = this.outlet.onsite_unavailable_message.replace('{qName}', this.selectedQueue.name)
                    }
                    this.error_msg = msg ? msg : unavailable_msg;
                }
            });
        },
        printOut() {
          if (window.webkit === undefined || window.webkit.messageHandlers === undefined) {
            alert("Printing failed. Due to browser restrictions, please install Aptsys QMS and open this webpage.\nInstall URL: https://apps.apple.com/tn/app/aptsys-qms/id1557160289");
            return;
          }
            axios.post('/api/printContent', {
                outlet_id: this.outlet.id,
                queue_id: this.selectedQueue.id,
                service_id: this.selectedServices.id,
                queue_no: this.q_no,
                queue_length: this.queueLength,
                estimated_time: this.estimateTime,
            }).then(result => {
                if (result.data && result.data !== ''){
                    window.webkit.messageHandlers.printMsg.postMessage([
                        this.printerIP,
                        9100,
                        result.data
                    ]);
                }
            });
            if (!this.selectedQueue.direct_print) this.clear();
        },
        submitDeclaration() {
            let q = this.tempQ
            this.tempQ = null
            if (this.travel == 1 || this.symptoms == 1 || this.servingNotice == 1 || this.closeContact == 1) {
                this.travel = null
                this.symptoms = null
                this.servingNotice = null
                this.closeContact = null
                this.showDeclaration = false
                this.declarationMsg = 'Please note that any person returning a temperature reading at or above 37.5℃ or has answered YES to the questions above will not be able to enter the premises. This is for the health and safety of all occupants of the clinic. We seek your kind understanding.'
                this.declarationAlert = true
            } else if (this.travel == null || this.symptoms == null || this.servingNotice == null || this.closeContact == null) {
                this.declarationMsg = 'Please answer all the questions.'
                this.declarationAlert = true
            } else {
                this.travel = null
                this.symptoms = null
                this.servingNotice = null
                this.closeContact = null
                this.showDeclaration = false
                this.showForm(q)
            }
        },
        getQueues() {
            axios.get('/api/get_available_queues/' + this.outlet.id,{
              loading: false,
            }).then(response => {
                this.queues = response.data
            })
        }
    },
    beforeMount() {
      console.log(this.$vuetify.breakpoint.width)
      console.log(this.$vuetify.breakpoint.xs)
      console.log(this.$vuetify.breakpoint.sm)
      console.log(this.$vuetify.breakpoint.md)
      console.log(this.$vuetify.breakpoint.lg)
        axios.get('/api/getOutletIP?oid=' + this.outlet.id).then(response => {
            this.printerIP = response.data.ip;
        });
        this.getQueues()
    },
    onIdle() {
        if (this.outlet.screen_saver){
            this.screensaver = true
        }
    },
    created() {
        setInterval(function () {
            this.getQueues()
        }.bind(this), 3000);
    }
}
</script>

<style>
.highlight {
    font-weight: bold;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Onsite.vue